@if (svg) {
  <mat-icon class="core-svg" [svgIcon]="svg!"> </mat-icon>
}